import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import care01 from "../assets/images/care01.png";

import Box from '@mui/material/Box';
import Bottom from "../Bottom";
import Top from "../Top";

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import { useEffect } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const Version = () => {
  const navigate = useNavigate();


  return (
    <Box>
      <Top title="버전 및 라이센스" />
      <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 12, pb: 12, minWidth:320 }}>



        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            앱 버전
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: '#fbfbfb', }}>
            <Typography sx={{ mb: 2, fontSize: 14, fontWeight: 700 }}>V. 1.0 </Typography>
            <Divider />
            <Typography sx={{mt:2, fontSize: 14, fontWeight: 700 }}>B. 1.0</Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            라이센스
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: '#fbfbfb',  }}>
            <Typography sx={{ mb: 1, fontSize: 14, fontWeight: 700 }}>Animation Icon </Typography>
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- FLATICON </Typography>
            <Typography sx={{ mb: 2, fontSize: 14, overflowWrap: 'break-word', ml:1 }}><a href="https://www.flaticon.com/kr/legal" title="애니메이션 아이콘" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://www.flaticon.com/kr/legal</a></Typography>
            <Divider />
            <Typography sx={{ mb: 1, mt: 2, fontSize: 14, fontWeight: 700 }}> React MUI </Typography>
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- MUI X </Typography>
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word', ml:1  }}><a href="https://mui.com/x/introduction/licensing/" title="MUI X" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://mui.com/x/introduction/licensing </a></Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            건강관리 출처
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: '#fbfbfb', }}>
            <Typography sx={{ mb: 1, fontSize: 14, fontWeight: 700 }}>권장섭취량, 운동량, 영양성분, 칼로리</Typography>
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- 한국영양학회</Typography>
            <Typography sx={{ mb: 1, fontSize: 14, overflowWrap: 'break-word', ml:1 }}><a href="https://www.kns.or.kr/" title="한국영양학회" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://www.kns.or.kr </a></Typography>
            
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- 식품안전나라 </Typography>
            <Typography sx={{ mb: 1, fontSize: 14, overflowWrap: 'break-word', ml:1 }}> <a href="https://www.foodsafetykorea.go.kr/main.do" title="식품안전나라" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://www.foodsafetykorea.go.kr </a></Typography>

            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- 질병관리청(국가건강정보포털) </Typography>
            <Typography sx={{ mb: 2, fontSize: 14, overflowWrap: 'break-word', ml:1 }}> <a href="https://health.kdca.go.kr/healthinfo/biz/health/main/mainPage/main.do" title="질병관리청" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://health.kdca.go.kr</a></Typography>
            <Divider />

            <Typography sx={{ mb: 1, mt: 2, fontSize: 14, fontWeight: 700 }}>칼로리계산, BMI 계산방법</Typography>
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- 질병관리청(국가건강정보포털) </Typography>
            <Typography sx={{ mb: 2, fontSize: 14, overflowWrap: 'break-word', ml:1 }}> <a href="https://health.kdca.go.kr/healthinfo/biz/health/main/mainPage/main.do" title="질병관리청" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://health.kdca.go.kr</a></Typography>
            <Divider />
            <Typography sx={{ mb: 1, mt: 2,  fontSize: 14, fontWeight: 700 }}>건강뉴스, 운동영상, 맞춤플랜의 레시피 등 </Typography>
            <Typography sx={{ fontSize: 14, overflowWrap: 'break-word' }}>- 듀얼헬스케어 생성 콘텐츠</Typography>
            <Typography sx={{ mb: 1, fontSize: 14, overflowWrap: 'break-word', ml:1 }}> <a href="https://blog.naver.com/dualhealth_official" title="듀얼헬스케어" target='_blank' style={{ textDecoration: 'none', color: '#777', fontSize: 14 }}>https://blog.naver.com/dualhealth_official</a></Typography>
          </AccordionDetails>
        </Accordion>



      </Container>
      <Bottom />
    </Box>
  );
}

export default Version;